// src/components/CDLoanHome.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, NavLink } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css"; // Font Awesome for icons

const CDLoanHome = () => {
  return (
    <div className="dashboard-container">
      <style>
        {`
          /* General Page Styling */
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }

         html, body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Poppins', sans-serif;
  background: linear-gradient(135deg, #f3eae2, #e4d5c7);
  height: auto;
  min-height: 100vh;
  overflow-y: auto; /* ✅ Allows scrolling if needed */
}

        .dashboard-container {
  display: flex;
  width: 90%;
  max-width: 1200px;
  min-height: 100vh; /* ✅ Ensures the dashboard expands with content */
  height: auto;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
  overflow-y: auto; /* ✅ Allows scrolling inside the dashboard */
}

        .sidebar {
  width: 280px;
  background: #2c3e50;
  color: white;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.sidebar nav ul {
  list-style: none;
  padding: 0;
}

          .sidebar h2 {
            text-align: center;
            font-size: 24px;
            font-weight: bold;
            padding-bottom: 15px;
            border-bottom: 2px solid #34495e;
          }


          .sidebar nav ul li {
            margin: 15px 0;
          }

        .sidebar nav ul li {
  margin: 15px 0;
}

.sidebar nav ul li a {
  text-decoration: none;
  color: white;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 6px;
  transition: all 0.3s ease-in-out;
}

.sidebar nav ul li a:hover,
.sidebar nav ul li a.active-link {
  background-color: #34495e;
  transform: scale(1.05);
}

          .sidebar nav ul li a i {
            margin-right: 10px;
          }

          .sidebar nav ul li a:hover,
          .sidebar nav ul li a.active-link {
            background-color: #34495e;
            transform: scale(1.05);
          }

          /* Back Button */
          .back-button {
            width: 100%;
            padding: 10px;
            background: #c0392b;
            color: white;
            font-size: 16px;
            font-weight: bold;
            border: none;
            cursor: pointer;
            border-radius: 6px;
            transition: all 0.3s ease-in-out;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .back-button i {
            margin-right: 8px;
          }

          .back-button:hover {
            background: #a93226;
            transform: scale(1.05);
          }

          /* Main Content */
        .content {
  flex: 1;
  padding: 30px;
  background: #fdfdfd;
  text-align: center;
  overflow-y: auto; /* ✅ Enables scrolling if content overflows */
}
          .content h2 {
            font-size: 24px;
            margin-bottom: 15px;
            color: #2c3e50;
          }

          .content p {
            font-size: 16px;
            color: #555;
          }

          /* Responsive Design */
          @media screen and (max-width: 768px) {
            .dashboard-container {
              flex-direction: column;
              height: auto;
            }

            .sidebar {
              width: 100%;
              padding: 15px;
              text-align: center;
            }

            .sidebar nav ul li {
              margin: 10px 0;
            }

            .back-button {
              width: 80%;
              margin: auto;
            }
          }
        `}
      </style>

      <aside className="sidebar">
        <h2>CD Loan</h2>
        <nav>
          <ul>
            <li>
              <NavLink to="/cd-loan/new" activeClassName="active-link">
                <i className="fas fa-file-alt"></i> New CD Loan
              </NavLink>
            </li>
            <li>
              <NavLink to="/cd-loan/receiver" activeClassName="active-link">
                <i className="fas fa-money-check-alt"></i> Loan Receiver
              </NavLink>
            </li>
            <li>
              <NavLink to="/cd-loan/ledger" activeClassName="active-link">
                <i className="fas fa-book"></i> Loan Ledger
              </NavLink>
            </li>
            <li>
              <NavLink to="/cd-loan/reports" activeClassName="active-link">
                <i className="fas fa-chart-pie"></i> Loan Reports
              </NavLink>
            </li>
            <li>
              <NavLink to="/cd-loan/partnerwise-report" activeClassName="active-link">
                <i className="fas fa-user-friends"></i> Partnerwise Report
              </NavLink>
            </li>
            <li>
              <NavLink to="/cd-loan/due-report" activeClassName="active-link">
                <i className="fas fa-exclamation-triangle"></i> Due Report
              </NavLink>
            </li>
            <li>
              <NavLink to="/cd-loan/partnerwise-due-report" activeClassName="active-link">
                <i className="fas fa-users"></i> Partnerwise Due Report
              </NavLink>
            </li>
            <li>
              <button onClick={() => window.history.back()} className="back-button">
                <i className="fas fa-arrow-left"></i> Back
              </button>
            </li>
          </ul>
        </nav>
      </aside>
      <main className="content">
        <h2>Welcome to the CD Loan Section</h2>
        <p>Select an option from the menu to proceed.</p>
      </main>
    </div>
  );
};

export default CDLoanHome;
